import { z } from "zod"
import { DATE_ORDER_OPTIONS, DATE_SEPARATOR_OPTIONS } from "../../utils/date-format"

export const CalendarSettingsTypeSchema = z.enum(["user", "org", "project"])

export const CalendarSettingsDateFormatSpecsSchema = z.object({
  dateOrder: z.enum(DATE_ORDER_OPTIONS),
  dateSeparator: z.enum(DATE_SEPARATOR_OPTIONS),
  includeTime: z.boolean().optional(),
})

export const CalendarSettingsHolidaySchema = z.object({
  id: z.string(),
  dateKey: z.string(),
  name: z.string(),
  recurring: z.boolean(),
})

export const CalendarSettingsResponseItemSchema = z.object({
  id: z.string(),
  type: CalendarSettingsTypeSchema,
  userId: z.string().optional(),
  orgId: z.string().optional(),
  projectId: z.string().optional(),
  holidays: z.array(CalendarSettingsHolidaySchema),
  weekendDays: z.array(z.number().int().min(0).max(6)),
  firstDayOfWeek: z.number().int().min(0).max(6),
  dateFormatSpecs: CalendarSettingsDateFormatSpecsSchema,
  timeZone: z.string(),
})

export const CalendarSettingsResponseSchema = z.object({
  calendarSettingsById: z.record(CalendarSettingsResponseItemSchema),
})

export type CalendarSettingsDateFormatSpecs = z.infer<typeof CalendarSettingsDateFormatSpecsSchema>
export type CalendarSettingsHoliday = z.infer<typeof CalendarSettingsHolidaySchema>
export type CalendarSettingsResponseItem = z.infer<typeof CalendarSettingsResponseItemSchema>
export type CalendarSettingsResponse = z.infer<typeof CalendarSettingsResponseSchema>
